import { useCallback, useState } from "react";
import { IMatch, UpcomingMatch } from "../types/types";
import {
  fetchPlayedMatches,
  fetchUpcomingMatchData,
  fetchPlayoffMatchData,
} from "../services/services";
import { MatchesContext } from "./context";
import { usePeriodicRefetch } from "../hooks/usePeriodicRefetch";
import { SCOREBOARD_POLL_MS } from "../utils/polling";

export const MatchesProvider = ({ children }: { children: React.ReactNode }) => {
  const [upcomingMatches, setUpcomingMatches] = useState<UpcomingMatch[]>();
  const [playedMatches, setPlayedMatches] = useState<IMatch[]>();
  const [playoffMatches, setPlayoffMatches] = useState<UpcomingMatch[]>();
  const [loading, setLoading] = useState(true);

  const fetchMatches = useCallback(async () => {
    try {
      const [playedData, upcomingData, allData] = await Promise.all([
        fetchPlayedMatches(),
        fetchUpcomingMatchData(),
        fetchPlayoffMatchData(),
      ]);
      setPlayedMatches(playedData);
      setUpcomingMatches(upcomingData);
      setPlayoffMatches(allData);
    } catch (err) {
      console.error("Failed to load match data: ", err);
    } finally {
      setLoading(false);
    }
  }, []);

  usePeriodicRefetch(fetchMatches, SCOREBOARD_POLL_MS);
  return (
    <MatchesContext.Provider value={{ upcomingMatches, playedMatches, playoffMatches, loading }}>
      {children}
    </MatchesContext.Provider>
  );
};
